
import { Frame } from 'lucide-react';
import { AceAvatarFramesGallery } from '@/components/help-center/aces/AceAvatarFramesGallery';
import { resolvePowerAvatarFrames } from '@/lib/ace-avatar-frames';
import type { PowerInfo } from '@/lib/powers-data';

type PowerAvatarFramesSectionProps = {
  power: PowerInfo;
};

export default function PowerAvatarFramesSection({ power }: PowerAvatarFramesSectionProps) {
  const frames = resolvePowerAvatarFrames(power);
  if (!frames?.length) return null;

  return (
    <section className="border-b border-gray-100 bg-gray-50 py-14">
      <div className="mx-auto max-w-7xl px-6">
        <header className="mb-8">
          <div className="mb-3 flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-amber-50 text-amber-600">
              <Frame className="h-4 w-4" />
            </div>
            <p className="font-poppins text-xs font-semibold uppercase tracking-widest text-amber-600">
              Molduras
            </p>
          </div>
          <h2 className="font-poppins text-2xl font-bold text-gray-900 md:text-3xl">Avatar frames</h2>
        </header>
        <p className="mb-8 max-w-3xl font-inter text-sm leading-relaxed text-gray-600 md:text-base">
          Molduras disponíveis para assinantes deste power. Aplique-as em Definições da conta → Avatar
          → Frame.
        </p>
        <AceAvatarFramesGallery frames={frames} />
      </div>
    </section>
  );
}
